import { createNgModule, EnvironmentInjector, Type } from '@angular/core';
import { map, take, takeUntil } from 'rxjs/operators';
import { getRouteInputMetadata } from '../route-input.decorator';
import { ClonedRouterOutlet, OutletInjector } from './cloned-router-outlet';
import { FeatureDynamicComponentsService } from '../../feature';
import { isReactive, SIGNAL } from '@angular/core/primitives/signals';
import * as i0 from "@angular/core";
import * as i1 from "../../feature";
export let CustomRouterOutlet = /*#__PURE__*/(() => {
  class CustomRouterOutlet extends ClonedRouterOutlet {
    constructor(dynamicComponentsService) {
      super();
      this.dynamicComponentsService = dynamicComponentsService;
    }
    // ngOnInit(): void {
    // 	if (!this.activated) {
    // 	  // If the outlet was not instantiated at the time the route got activated we need to populate
    // 	  // the outlet when it is initialized (ie inside a NgIf)
    // 	  const context = this.parentContexts.getContext(this.name);
    // 	  if (context && context.route) {
    // 		if (context.attachRef) {
    // 		  // `attachRef` is populated when there is an existing component to mount
    // 		  this.attach(context.attachRef, context.route);
    // 		} else {
    // 		  // otherwise the component defined in the configuration is created
    // 		  this.activateWith(context.route, context.resolver || null);
    // 		}
    // 	  }
    // 	}
    // }
    // called from https://github.com/angular/angular/blob/41c6f7a0796193728981572c8bef900b23da6c3f/packages/router/src/operators/activate_routes.ts#L204
    // highly interesting file, but pretty much impossible to manipulate.
    // activateWith now only contains our custom logic, all default logic has been placed in separate methods so that it is easier to update when needed.
    activateWith(activatedRoute, environmentInjector) {
      let component = this.activateWith_prepareAndGetComponentCtor(activatedRoute);
      // custom logic for fetching 
      this.dynamicComponentsService.resolveComponentReplacement(component).pipe(take(1)).subscribe(componentInfo => {
        if (componentInfo) {
          component = componentInfo.component;
          this.activateCustomComponent(activatedRoute, componentInfo, environmentInjector);
          // custom
          this.patchRouteInputs(component);
          this.activateWith_finalize();
          // console.log('replacementComponent', ReplacementComponent);
        } else {
          super.activateWith(activatedRoute, environmentInjector);
          this.patchRouteInputs(component);
        }
      });
    }
    // like activateWith_createComponent, but uses ComponentInfo and its passed Module if specified.
    activateCustomComponent(activatedRoute, componentInfo, environmentInjector) {
      const component = componentInfo.component;
      const location = this.location;
      const childContexts = this.parentContexts.getOrCreateContext(this.name).children;
      const injector = new OutletInjector(activatedRoute, childContexts, location.injector, this.routerOutletData);
      let ngModuleRef = undefined;
      if (componentInfo.module) {
        // console.warn('CustomRouterOutlet.activateCustomComponent received a ComponentInfo with specific module.')
        // create a new NgModuleRef from componentInfo as child of this component's injector (=injector of parent module)
        ngModuleRef = componentInfo.module ? createNgModule(componentInfo.module, injector) : undefined;
      }
      this.activated = location.createComponent(component, {
        index: location.length,
        injector,
        environmentInjector: environmentInjector,
        ngModuleRef
      });
    }
    getFutureRouteSnapshot() {
      const snapshot = this._activatedRoute._futureSnapshot;
      return snapshot;
    }
    patchRouteInputs(Component) {
      const metas = getRouteInputMetadata(Component);
      // console.log('outlet >>> activateWith >>> patchRouteInputs',metas)
      if (!metas.length) return;
      const snapshot = this.getFutureRouteSnapshot();
      const route = this._activatedRoute;
      let usesObservables = false;
      // check for requested observables, memorize data at inputProp['useObservable']
      metas.forEach(inputProp => {
        // const assumeObservable = inputProp.property.endsWith('$');
        const explicitObservableSetting = typeof inputProp.settings.observable === 'boolean';
        const useObservable = explicitObservableSetting || false;
        if (useObservable) usesObservables = true;
        inputProp['useObservable'] = useObservable;
      });
      const component = this.component;
      const assertPropertyExists = (obj, key, type) => {
        if (typeof obj[key] === 'undefined') throw new Error('@RouteInput error: route has no ' + type + ' type data named ' + key);
      };
      const makeObservable = inputProp => {
        return route[inputProp.type].pipe(map(record => {
          assertPropertyExists(record, inputProp.name, inputProp.type);
          return record[inputProp.name];
        }), takeUntil(this.deactivateEvents));
      };
      metas.forEach(inputProp => {
        const useObservable = inputProp['useObservable'];
        let propValue;
        if (useObservable) {
          propValue = makeObservable(inputProp);
          component[inputProp.property] = propValue;
        } else {
          assertPropertyExists(snapshot[inputProp.type], inputProp.name, inputProp.type);
          // applyValueToInputField
          if (isReactive(component[inputProp.property])) {
            makeObservable(inputProp).subscribe(value => {
              const inputSignalNode = component[inputProp.property][SIGNAL];
              // console.log('inputSignalNode',inputSignalNode)
              inputSignalNode.applyValueToInputSignal(inputSignalNode, value);
            });
            // component[inputProp.property].set(propValue);
          } else {
            propValue = snapshot[inputProp.type][inputProp.name];
            component[inputProp.property] = propValue;
          }
        }
        // console.log('patched',inputProp.property,propValue,component)
      });
    }
    static {
      this.ɵfac = function CustomRouterOutlet_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomRouterOutlet)(i0.ɵɵdirectiveInject(i1.FeatureDynamicComponentsService));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: CustomRouterOutlet,
        selectors: [["custom-router-outlet"]],
        exportAs: ["outlet"],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return CustomRouterOutlet;
})();